
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

// extend once so dayjs can parse "DD/MM/YYYY"
dayjs.extend(customParseFormat)

export default {
  name: 'IpoSubscriptions',
  // Example expiry date
  // Fetch and validate on the server via asyncData so Nuxt can return a 404 before rendering the page.
  async asyncData({ $config, route, error }) {
    try {
      const response = await fetch(`${$config.apiBaseUrl}/data`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `Command=getipodetails&IPOCode=${route.params.IPOCode}`,
      })
      const res = await response.json()
      if (res.Body === null) {
        return error({ statusCode: 404, message: "This page does not exist" })
      }
      const ipo = res.Body

      // Server-side validation: if IPO is not available/showable, return 404 before rendering
      if (ipo.Status === 'Initial' || ipo.IsCompleted) {
        return error({ statusCode: 404, message: 'Page expired' })
      }

      return { ipo }
    } catch (err) {
      console.log(err)
      // Optionally surface a server error:
      // return error({ statusCode: 500, message: 'Failed to load IPO details' })
      return {}
    }
  },
  data() {
    return {
      ipo: null,
      bankLogosalec: [
        'logos/enbd-logo',
        'logos/adcb-logo_jrc5mk',
        'logos/adib-logo_kvvoju',
        'logos/al-maryah-bank',
        'logos/cbd-logo_ocg5wq',
        'logos/dib-logo_vkgiut',
        'logos/emirates-islamic-logo_svbabb',
        'logos/fab-logo_mtezba',
        'logos/mashreq-logo_hainpb',
        'logos/wio-bank-logo',
      ],
      bankLogosdubizzle: [
        'logos/enbd-logo',
        'logos/adcb-logo_jrc5mk',
        'logos/fab-logo_mtezba',
        'logos/adib-logo_kvvoju',
        'logos/emirates-islamic-logo_svbabb',
        'logos/dib-logo_vkgiut',
        'logos/al-maryah-bank',
        'logos/mashreq-logo_hainpb',
        'logos/wio-bank-logo',
      ],
      video1: {
        videoTitle: 'IPO Subscriptions via DFM App',
        videoId: '787488635',
        videoThumb: 'visuals/dfm-visual-8_g0dosf',
      },
    }
  },
  computed: {
    lang() {
      if (this.$i18n.locale == 'en') {
        return 'En'
      } else {
        return 'Ar'
      }
    },
    logo() {
      if (this.ipo && this.ipo.Claims.length > 0) {
        return this.ipo.Claims.filter((claim) => claim.ClaimKey == 'LogoURL')[0][`ClaimKeyNote${this.lang}`]
      }
      return ''
    },
    desc() {
      if (this.ipo && this.ipo.Claims.length > 0) {
        return this.ipo.Claims.filter((claim) => claim.ClaimKey == 'CompanyDescription')[0][`ClaimKeyInfo${this.lang}`]
      }
      return ''
    },
    IPOShortName() {
      if (this.ipo) {
        return this.ipo[`IPOShortName${this.lang}`]
      }
      return ''
    },
    IPOName() {
      if (this.ipo) {
        return this.ipo[`IPOName${this.lang}`]
      }
      return ''
    },
    website() {
      if (this.ipo && this.ipo.Claims.length > 0) {
        return this.ipo.Claims.filter((claim) => claim.ClaimKey == 'SubscriptionCompanyWebsiteURL')[0][`ClaimKeyNote${this.lang}`]
      }
      return ''
    },
    phone() {
      if (this.ipo && this.ipo.Claims.length > 0) {
        return this.ipo.Claims.filter((claim) => claim.ClaimKey == 'CompanyTelephoneNumber')[0].ClaimKeyValue
      }
      return ''
    },
    email() {
      if (this.ipo && this.ipo.Claims.length > 0) {
        return this.ipo.Claims.filter((claim) => claim.ClaimKey == 'CompanyEmail')[0].ClaimKeyValue
      }
      return ''
    },
    prospectusURL() {
      if (this.ipo && this.ipo.Claims.length > 0) {
        return this.ipo.Claims.filter((claim) => claim.ClaimKey == 'ProspectusURL')[0][`ClaimKeyNote${this.lang}`]
      }
      return ''
    },
    sharesOffered() {
      return this.ipo.Claims.filter((claim) => claim.ClaimKey == 'SharesOffered')[0].ClaimKeyValue
    },
    priceRange() {
      if (this.ipo && this.ipo.Claims.length > 0) {
        return this.ipo.Claims.filter((claim) => claim.ClaimKey == 'PriceRange')[0].ClaimKeyValue
      }
      return ''
    },
    tradingStartingDate() {
      if (this.ipo && this.ipo.Claims.length > 0) {
        return this.ipo.Claims.filter((claim) => claim.ClaimKey == 'TradingStartDate')[0].ClaimKeyValue
      }
      return ''
    },
    sector() {
      if (this.ipo && this.ipo.Claims.length > 0) {
        return this.ipo.Claims.filter((claim) => claim.ClaimKey == 'Sector')[0][`ClaimKeyTitle${this.lang}`]
      }
      return ''
    },
    proposedSymbol() {
      if (this.ipo && Array.isArray(this.ipo.Claims) && this.ipo.Claims.length > 0) {
        const claim = this.ipo.Claims.find(c => c?.ClaimKey === 'ProposedSymbol')
        return claim?.ClaimKeyValue || '--'
      }
      return '--'
    },
    companyFullNameClaim() {
      if (this.ipo && Array.isArray(this.ipo.Claims) && this.ipo.Claims.length > 0) {
        const claim = this.ipo.Claims.find(c => c?.ClaimKey === 'CompanyFullName')
        return claim?.ClaimKeyValue || '--'
      }
      return '--'
      // if (this.ipo && this.ipo.Claims.length > 0) {
      //   return this.ipo.Claims.filter((claim) => claim.ClaimKey == 'CompanyFullName')[0][`ClaimKeyTitle${this.lang}`]
      // }
      // return ''
    },
    tradingEndDate() {
      if (this.ipo && this.ipo.Claims.length > 0) {
        return this.ipo.Claims.filter((claim) => claim.ClaimKey == 'TradingEndDate')[0].ClaimKeyValue
      }
      return ''
    },
    allocationDate() {
      if (this.ipo && this.ipo.Claims.length > 0) {
        return this.ipo.Claims.filter((claim) => claim.ClaimKey == 'AllocationDate')[0].ClaimKeyValue
      }
      return ''
    },
    refundStartDate() {
      if (this.ipo && this.ipo.Claims.length > 0) {
        return this.ipo.Claims.filter((claim) => claim.ClaimKey == 'RefundDate')[0].ClaimKeyValue
      }
      return ''
    },
    listingDate() {
      if (this.ipo && this.ipo.Claims.length > 0) {
        return this.ipo.Claims.filter((claim) => claim.ClaimKey == 'ListingDate')[0].ClaimKeyValue
      }
      return ''
    },
    documents() {
      if (this.ipo && this.ipo.Claims.length > 0) {
        return this.ipo.Claims.filter((claim) => claim.ClaimKeyType == 'Documents')
      }
      return ''
    },
  },
  mounted() {
    // console.log(this.$route.params.IPOCode)
  },
}
